import { reactive } from "vue";

export interface ConfirmationOptions {
  cancelText?: string;
  confirmText?: string;
  isDestructive?: boolean;
  message: string;
  title: string;
}

interface ConfirmationState {
  cancelText: string;
  confirmText: string;
  isDestructive: boolean;
  isOpen: boolean;
  message: string;
  title: string;
}

const state = reactive<ConfirmationState>({
  cancelText: "Abbrechen",
  confirmText: "Bestätigen",
  isDestructive: false,
  isOpen: false,
  message: "",
  title: "",
});

let pendingResolve: ((value: boolean) => void) | null = null;

export function useConfirmation() {
  function confirm(options: ConfirmationOptions): Promise<boolean> {
    state.cancelText = options.cancelText ?? "Abbrechen";
    state.confirmText = options.confirmText ?? "Bestätigen";
    state.isDestructive = options.isDestructive ?? false;
    state.message = options.message;
    state.title = options.title;
    state.isOpen = true;

    return new Promise<boolean>((resolve) => {
      pendingResolve = resolve;
    });
  }

  function resolve(value: boolean) {
    state.isOpen = false;
    if (pendingResolve) {
      pendingResolve(value);
      pendingResolve = null;
    }
  }

  return {
    confirm,
    resolve,
    state,
  };
}
